module.exports = __webpack_public_path__ + "static/favicon-a58781e175863c6a86341ff2302a49c9.ico";